import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";
import { PaidTabs } from "@/patterns/paid-landings/paid-tabs/src/paid-tabs";

import { TabsProps } from "../src/paid-landing.template";

const anchorStyles = css({
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".tab-panels section img": {
        "max-width": "632px"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".pullquote-quote p.quote-name": {
        textTransform: "uppercase"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".pullquote-quote p.quote-company": {
        "textTransform": "uppercase",
        "margin-top": "0.5rem"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".tab-content ul": {
        padding: "0 0 0 20px",
        listStyleType: "none"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".tab-content ul li::before": {
        content: "''",
        position: "absolute",
        height: 9,
        width: 11,
        padding: "14px 0 0 0",
        margin: "0 0 0 -20px",
        background:
            "url('data:image/svg+xml;base64,ICAgIDxzdmcKICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICAgICAgdmVyc2lvbj0iMS4yIgogICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICAgICB2aWV3Qm94PSIwIDAgMzIgMzAiCiAgICAgICAgd2lkdGg9IjExIgogICAgICAgIGhlaWdodD0iOSIKICAgID4KICAgICAgICA8cGF0aCBkPSJtMS41IDE2LjRjMS44LTEuNyA0LjItMC4zIDQuMi0wLjNsNS42IDUuOSAxNS40LTE4LjdjMCAwIDEuNy0xLjIgMy41IDAuMSAxLjkgMS40IDAuOCAzLjYgMC44IDMuNmwtMTggMjJoLTJsLTkuMS04LjdjMCAwLTIuMS0yLjItMC40LTMuOXoiIC8+CiAgICA8L3N2Zz4=') center center no-repeat"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".tab-panels div.tab-testimony": {
        paddingBlockStart: "0"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& > div": {
        margin: "40px 0 32px 0"
    },
    [media.below.sm]: {
        // overriding custom tab styles in paid-tabs.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > div": {
            margin: "40px 0 0 0"
        }
    }
});

const jsmAndConfTabsStyles = css({
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.tab-group .tab-group-inner button[aria-selected="true"]': {
        border: `2px solid var(--lp-tabs-hover, ${wacToken(
            "color.primary.blue"
        )})`
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div.tab-group .tab-group-inner button[aria-selected="false"]': {
        color: `var(--lp-tabs-unselected, ${wacToken("color.primary.black")})`,
        border: "2px solid transparent"
    },
    // overriding custom tab styles in paid-tabs.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div.tab-group .tab-group-inner button[aria-selected="true"]:hover': {
        border: `2px solid var(--lp-tabs-hover, ${wacToken(
            "color.primary.blue"
        )})`
    }
});

export const PaidTabsSection: React.FunctionComponent<TabsProps> = (
    tabsProps
) => {
    const { styles: tabsStyles, landingType, ...otherTabsProps } = tabsProps;

    return (
        <div
            className="tabs-section"
            css={[
                css({
                    background: wacToken("color.neutral.light0")
                }),
                landingType === "jira-software-anchor" && anchorStyles,
                landingType === "jira-service-management-anchor" &&
                    anchorStyles,
                landingType === "jira-service-management-anchor" &&
                    jsmAndConfTabsStyles,
                landingType === "confluence-rebranded-anchor" && anchorStyles,
                landingType === "confluence-rebranded-anchor" &&
                    jsmAndConfTabsStyles
            ]}
        >
            <PaidTabs {...otherTabsProps} />
        </div>
    );
};
PaidTabsSection.displayName = "PaidTabs";
